import type { ThemePreference } from '@ctcells/core'

/**
 * 테마 선택기의 아이콘 셋(eric 2026-09-23 「시스템 · 라이트 · 다크를 각각 아이콘으로」).
 * 🔴 그림은 `aria-hidden` 이고 이름은 `Segmented` 의 `title` 이 진다 — 색·모양만으로 가르지 않는다.
 * 선은 `currentColor` 라 고른 칸(강조 배경)에서는 강조 전경색으로 뒤집힌다.
 */
const COMMON = {
  'aria-hidden': true,
  fill: 'none',
  stroke: 'currentColor',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  strokeWidth: 1.8,
  viewBox: '0 0 16 16',
} as const

/** 시스템 — 모니터 */
function SystemIcon() {
  return (
    <svg {...COMMON}>
      <rect height="8.5" rx="1.5" width="12" x="2" y="2.5" />
      <path d="M5.5 13.5h5M8 11v2.5" />
    </svg>
  )
}

/** 라이트 — 해 */
function SunIcon() {
  return (
    <svg {...COMMON}>
      <circle cx="8" cy="8" r="3" />
      <path d="M8 1.5v1.6M8 12.9v1.6M1.5 8h1.6M12.9 8h1.6M3.4 3.4l1.1 1.1M11.5 11.5l1.1 1.1M3.4 12.6l1.1-1.1M11.5 4.5l1.1-1.1" />
    </svg>
  )
}

/** 다크 — 달 */
function MoonIcon() {
  return (
    <svg {...COMMON}>
      <path d="M13.5 9.8A5.6 5.6 0 0 1 6.2 2.5a5.6 5.6 0 1 0 7.3 7.3z" />
    </svg>
  )
}

export function ThemeIcon({ preference }: { preference: ThemePreference }) {
  if (preference === 'system') return <SystemIcon />
  if (preference === 'dark') return <MoonIcon />
  return <SunIcon />
}
